import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import * as Ant from "antd";
function Loader() {
    return (_jsx(Ant.Space, { align: "center", className: "loader", children: _jsx(Ant.Spin, { size: "large" }) }));
}
export default React.memo(Loader);
